import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { MatDivider } from '@angular/material/divider';
import {
  MatList,
  MatListItem,
  MatListItemAvatar,
  MatListItemLine,
  MatListItemTitle,
} from '@angular/material/list';
import { JsonPipe } from '@angular/common';
import { ClientEventFacadeService } from '@app/facade-services/client-event/client-event-facade.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ClientEvent } from '@app/facade-services/client-event/model/client-event';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { PageTitleComponent } from '@app/components/common/page-title/page-title.component';
import {
  MatAccordion,
  MatExpansionModule,
  MatExpansionPanel,
  MatExpansionPanelDescription,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';

@Component({
  selector: 'faxe-client-event-listner',
  imports: [
    MatDivider,
    MatList,
    MatListItem,
    MatListItemAvatar,
    MatListItemLine,
    MatListItemTitle,
    NgxJsonViewerModule,
    PageTitleComponent,
    MatAccordion,
    MatExpansionModule,
  ],
  templateUrl: './client-event-listner.component.html',
  styleUrl: './client-event-listner.component.scss',
})
export class ClientEventListnerComponent implements OnInit, OnDestroy {
  readonly panelOpenState = signal(false);
  private unsubscribe$ = new Subject<void>();
  clientEvents: ClientEvent[] = [];
  constructor(private clientEventFacadeService: ClientEventFacadeService) {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit(): void {
    this.clientEventFacadeService.clientEvent$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((clientEvent) => {
        this.clientEvents = clientEvent;
      });
  }
}
